import { Box, Grid, Typography, useTheme } from '@mui/material';

export type MarketingFeatureItem = {
  title: string;
  body: string;
};

type MarketingFeatureGridProps = {
  items: MarketingFeatureItem[];
  columns?: { xs?: number; md?: number };
};

export const MarketingFeatureGrid = ({
  items,
  columns = { xs: 12, md: 6 },
}: MarketingFeatureGridProps) => {
  const theme = useTheme();
  return (
    <Grid container spacing={3}>
      {items.map((item) => (
        <Grid item xs={columns.xs ?? 12} md={columns.md ?? 6} key={item.title}>
          <Box
            sx={{
              height: '100%',
              p: 3,
              borderRadius: 2,
              border: `1px solid ${theme.palette.greyShades.border1}`,
              bgcolor: 'background.paper',
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
              {item.title}
            </Typography>
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ lineHeight: 1.7 }}
            >
              {item.body}
            </Typography>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};
